import axiosInstance from "../utils/api";

import endpoints from '../constants/endpoints';



export const getListOfProducts = async () => {
    try {
        const response = await axiosInstance.get(endpoints.fetchListOfProducts)
        return response.data;
    } catch (error) {
        console.error('Error fetching products:', error);
        throw error;
    }
}


export const getSingleProductDetail = async (productId) => {
    try {
        const response = await axiosInstance.get(endpoints.fetchSingleProductDetail(productId))
        return response.data;
    } catch (error) {
        console.error('Error fetching product detail:', error);
        throw error;
    }
}
export const searchAndFilterProducts = async (searchTerm, category, subCategory, priceMin, priceMax, sockLevel, status_) => {
    try {
        const response = await axiosInstance.get(endpoints.searchAndFilterProducts(searchTerm, category, subCategory, priceMin, priceMax, sockLevel, status_))
        return response.data;
    } catch (error) {
        console.error('Error searching and filtering products:', error);
        throw error;
    }
}

export const updateProductDetail = async (productId, productData) => {
    try {
        const response = await axiosInstance.put(endpoints.updateProductDetail(productId), productData)
        return response.data;
    } catch (error) {
        console.error('Error updating product detail:', error);
        throw error;
    }
}

export const toggleProductStatus = async (productId) => {
    try {
        const response = await axiosInstance.put(endpoints.toggleProductStatus(productId))
        return response.data;
    } catch (error) {
        console.error('Error toggling product status:', error);
        throw error;
    }
}

export const getAllProductDefaultProperties = async () => {
    try {
        const response = await axiosInstance.get(endpoints.getAllProductDefaultProperties)
        return response.data;
    } catch (error) {
        console.error('Error fetching product default properties:', error);
        throw error;
    }

}

export const deleteProductsAdmin = async (productsIds) => {
    try {
        const response = await axiosInstance.delete(endpoints.delete_products, { data: { products_ids: productsIds } });
        return response.data;
    } catch (error) {
        console.error('Error deleting products:', error);
        throw error;
    }

}
